import { CATALOGUE_MODE } from "@constants";
import { Dialog } from "@mui/material";
import PropTypes from "prop-types";

import React from "react";

import {
    getAlertActionButtonImageSrc,
    getNoActionButtonImageSrc,
    getYesActionButtonImageSrc,
} from "@helpers/general";

import "./../index.css";
import useOrderSummeryAlert, {
    WorkflowAlerType,
} from "./OrderSummeryAlertHook";

export default function WorkflowAlert({
    isOrderAlert,
    setIsOrderAlert,
    handleCartChangedCLickEvent,
}: WorkflowAlerType): JSX.Element {
    const { onClose, isPrm, actionsButtons, t } =
        useOrderSummeryAlert(setIsOrderAlert);
    return (
        <Dialog
            onClose={onClose}
            open={isOrderAlert}
            container={() => document.querySelector(".fullscreen")}
            PaperProps={{
                sx: {
                    display: "flex!important",
                    gap: "50px!important",
                    alignItems: "center!important",
                    flexDirection: "column!important",
                    paddingTop: "0px!important",
                    paddingBottom: "0px!important",
                    color: "black!important",
                    height: "1230px!important",
                    width: "860px!important",
                    maxWidth: "unset!important",
                    maxHeight: "unset",
                    backgroundColor: "#FFFFFF!important",
                    borderRadius: "111px!important",
                    borderLeft: "1px solid #707070!important",
                    borderRight: "1px solid #707070!important",
                    borderBottom: "1px solid #707070!important",
                    borderTop: `15px solid var(--global-color)!important`,
                    top: "unset!important",
                    right: "unset!important",
                    left: "unset!important",
                    bottom: isPrm ? "-14%" : "unset",

                    zoom: `${
                        process.env.REACT_APP_MODE === CATALOGUE_MODE
                            ? "50%"
                            : "100%"
                    }`,
                },
            }}
            style={{ backdropFilter: "blur(5px)" }}
        >
            <div className="d-flex justify-content-center align-items-center w-100 order-alert-buttons-container">
                <img
                    alt="alert image"
                    className="order-alert-img"
                    src={getAlertActionButtonImageSrc(
                        actionsButtons as ActionsButtonsDesignType
                    )}
                />
            </div>
            <div className="text-center order-alert-container">
                <span>
                    {t(
                        "This promo code is not applicable to the items in your cart. Only certain items are eligible for this offer."
                    )}
                </span>
            </div>
            <div className="d-flex justify-content-center order-alert-buttons">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <img
                        className="order-alert-no-button"
                        alt="no image"
                        src={getNoActionButtonImageSrc(
                            actionsButtons as ActionsButtonsDesignType
                        )}
                        onClick={() => {
                            onClose();
                        }}
                    />
                    <span className="order-alert-button-text">{t("No")}</span>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <img
                        alt="yes image"
                        className="order-alert-yes-button"
                        src={getYesActionButtonImageSrc(
                            actionsButtons as ActionsButtonsDesignType
                        )}
                        onClick={handleCartChangedCLickEvent}
                    />
                    <span className="order-alert-button-text">{t("Yes")}</span>
                </div>
            </div>
        </Dialog>
    );
}

WorkflowAlert.propTypes = {
    isOrderAlert: PropTypes.bool.isRequired,
    setIsOrderAlert: PropTypes.func.isRequired,
    handleCartChangedCLickEvent: PropTypes.func.isRequired,
};
